import React, { useState } from 'react';
import RoastComment from '../sharedComponents/RoastComment';

// Roast-a-Comment, front and center: the real tool on the left, the roast
// board on the right playing a sample take and its verdict.
export default function RoastSection() {
  const [paused, setPaused] = useState(false);
  return (
    <section className="fi-roast" id="roast" aria-labelledby="fi-roast-h">
      <div className="fi-wrap fi-roast-g">
        <div>
          <h2 className="fi-h2" id="fi-roast-h">Roast-a-<em>Comment</em></h2>
          <p className="fi-sub">Paste the dumbest EV take you saw today. We send back a reply with receipts, ready to post. Your uncle will hate it.</p>
          <div style={{ marginTop: 22 }}>
            <RoastComment />
          </div>
        </div>
        <div
          className={`fi-vms${paused ? ' is-paused' : ''}`}
          role="img"
          aria-label="Roast board. Incoming take: it's all run on coal. Verdict: false. Even on the dirtiest grid, an EV's lifetime emissions beat a comparable gas car."
        >
          <div className="fi-vms-top">
            <span>The roast board</span>
            <span className="fi-lamps">
              <i aria-hidden="true" /><i aria-hidden="true" />
              <button type="button" onClick={() => setPaused(!paused)} aria-pressed={paused}>{paused ? 'Play' : 'Pause'}</button>
            </span>
          </div>
          <div className="fi-vms-in" aria-hidden="true">
            <div className="fi-msg"><span>Incoming take</span><span>"It's all run</span><span>on coal"</span></div>
            <div className="fi-msg fi-msg--2"><span>Verdict: false</span><span>Dirtiest grid?</span><span>EV still wins</span></div>
            <div className="fi-msg fi-msg--3"><span>Lifetime CO2</span><span>EV beats gas</span><span>Receipts below</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
